import * as React from 'react';

export type ModalPreviewLayoutSkin = 'dark' | 'light';

export interface ModalPreviewLayoutProps {
  dataHook?: string;
  actions?: React.ReactNode;
  title?: string;
  children: React.ReactNode;
  onClose: () => void;
  shouldCloseOnOverlayClick?: boolean;
  closeButtonTooltipText?: string;
  prevButtonProps?: PrevButtonProps;
  nextButtonProps?: NextButtonProps;
  skin?: ModalPreviewLayoutSkin;
  startDisplayingAtChildIndex?: number;
}

export type PrevButtonProps = {
  onClick?: (childIndexDisplayed: number) => {};
  tooltipText?: React.ReactNode;
};

export type NextButtonProps = {
  onClick?: (childIndexDisplayed: number) => {};
  tooltipText?: React.ReactNode;
};

export default class ModalPreviewLayout extends React.PureComponent<ModalPreviewLayoutProps> {}
